<template>
  <span class="chat-avatar" :title="user.display_name || [user.prenom, user.nom].filter(Boolean).join(' ')" :style="{ width: size + 'px', height: size + 'px' }">
    <v-avatar :size="size" :color="user.color || '#5865C3'"><v-img v-if="user.photo" :src="user.photo" /><span v-else class="chat-avatar__initials">{{ initials(user) }}</span></v-avatar>
    <span v-if="presenceDot" class="chat-avatar__status" :class="statusClass" :title="status.label" />
  </span>
</template>
<script>
import { initials, activity } from './helpers'
export default {
  props: { user: { type: Object, required: true }, size: { type: Number, default: 36 }, presence: { default: null }, presenceDot: Boolean },
  computed: { status() { return activity(this.presence) }, statusClass() { return !this.presence ? 'chat-avatar__status--offline' : this.presence.isAfk ? 'chat-avatar__status--away' : 'chat-avatar__status--online' } },
  methods: { initials }
}
</script>
<style scoped>
.chat-avatar{display:inline-flex;position:relative;flex-shrink:0;vertical-align:middle}.chat-avatar__initials{color:white;font-size:12px;font-weight:600;letter-spacing:.02em}.chat-avatar__status{position:absolute;bottom:-1px;right:-1px;width:10px;height:10px;border:2px solid var(--app-chat-rail,#fff);border-radius:50%}.chat-avatar__status--online{background:var(--app-success,#4caf50)}.chat-avatar__status--away{background:var(--app-warning,#fb8c00)}.chat-avatar__status--offline{background:#9aa1b1}
</style>
